// Mock data for Medium Plenty x Abu Dhabi (UAE workplace business card). Static/mocked content.


export const NAV_LINKS = [
  { label: "Work", to: "/work" },
  { label: "Studio", to: "/studio" },
  { label: "Inquiries", to: "/inquiries", arrow: true },
];

export const UAE = {
  eyebrow: "Architecture + Interiors — Abu Dhabi",
  heroIntro:
    "Medium Plenty brings its California design sensibility to the UAE — pairing thoughtful architecture and interiors with strategic spatial planning for the region's most forward-looking companies. With a satellite office in Abu Dhabi and deep experience in workplace interiors, we deliver design that is grounded, elegant, and built for what's next.",
  offerings: [
    {
      title: "Architecture & Interior Design",
      body:
        "Medium Plenty offers comprehensive architectural and interior design services with a focus on high-end residential projects, workplace and hospitality environments. Our expertise lies in crafting spaces that are both deeply considered and highly functional. With a strong design sensibility and a collaborative process, we tailor each project to reflect the values, identity, and goals of our clients.",
      img: "/mp/ghq-boardroom.jpg",
    },
    {
      title: "Construction Management",
      body:
        "Medium Plenty provides integrated construction management services to ensure our design vision is delivered with precision and efficiency. In the UAE, where workplace tenant improvements demand speed, coordination, and attention to detail, our hands-on approach helps navigate approvals, manage timelines, and maintain design integrity — resulting in well-executed spaces that are ready to support growth from day one.",
      img: "/mp/work/069a4643.jpg",
    },
  ],
  featured: {
    tag: "Featured Project — Workplace",
    title: "Global Headquarters",
    location: "Abu Dhabi, UAE",
    hero: "/mp/ghq-booths.jpg",
    blurb:
      "Situated in a premium high-rise, the project offers expansive city and Gulf views while rethinking what a contemporary workplace in the Middle East can be. In reimagining the Abu Dhabi headquarters for a global financial services firm, subtle references to Middle Eastern craft traditions and palettes root the design in its local context while maintaining an international sophistication.",
    images: [
      "/mp/ghq-artwall.jpg",
      "/mp/ghq-boardroom.jpg",
      "/mp/ghq-pantry.jpg",
      "/mp/ghq-sconce.jpg",
    ],
  },
  workTitle: "It starts here.",
  workBody:
    "Medium Plenty is ready to collaborate on your next project. Whether it be a full-floor build in an office tower, a beachside villa, or a luxury suite in a high-rise; we are ready to bring the idea into reality. Contact us to get the process started.",
  connectTitle: "There's plenty to share — let's connect.",
  connectSub: "Abu Dhabi | California",
  locations: [
    { city: "Al Reem Island", region: "Abu Dhabi, UAE", variant: "uae" },
    { city: "Northern California", region: "United States", variant: "ca" },
  ],
};

export const WORK = [
  // Workplace — elevated commercial (Global Headquarters, Abu Dhabi)
  { src: "/mp/ghq-lounge.jpg", cat: "Workplace" },
  { src: "/mp/ghq-artwall.jpg", cat: "Workplace" },
  { src: "/mp/ghq-boardroom.jpg", cat: "Workplace" },
  { src: "/mp/ghq-booths.jpg", cat: "Workplace" },
  { src: "/mp/ghq-pantry.jpg", cat: "Workplace" },
  { src: "/mp/ghq-sconce.jpg", cat: "Workplace" },
  { src: "/mp/ghq-reception.jpg", cat: "Workplace" },
  // Hospitality
  { src: "/mp/work/02-mediumplenty-stella.jpg", cat: "Hospitality" },
  { src: "/mp/work/stella-horiz-20.jpg", cat: "Hospitality" },
  { src: "/mp/work/stella-1-2.jpg", cat: "Hospitality" },
  { src: "/mp/work/stella-5-6.jpg", cat: "Hospitality" },
  { src: "/mp/work/kaseman-1s8a5194.jpg", cat: "Hospitality" },
  { src: "/mp/work/3-4-281-29.jpg", cat: "Hospitality" },
  { src: "/mp/work/3-4-282-29.jpg", cat: "Hospitality" },
  // Residential
  { src: "/mp/work/mirabeledits-1.jpg", cat: "Residential" },
  { src: "/mp/work/joliet-lippard-final-0206.jpg", cat: "Residential" },
  { src: "/mp/work/069a4610.jpg", cat: "Residential" },
  { src: "/mp/work/5-6.jpg", cat: "Residential" },
  { src: "/mp/work/kaseman-1s8a5097.jpg", cat: "Residential" },
  { src: "/mp/work/parker-residence-thumb.jpg", cat: "Residential" },
  { src: "/mp/work/069a4599.jpg", cat: "Residential" },
  { src: "/mp/work/mirabeledits-7.jpg", cat: "Residential" },
  { src: "/mp/work/9-10.jpg", cat: "Residential" },
  { src: "/mp/work/joliet-lippard-final-9638.jpg", cat: "Residential" },
  { src: "/mp/work/069a4645.jpg", cat: "Residential" },
  { src: "/mp/work/joliet-parker-final-9249.jpg", cat: "Residential" },
  { src: "/mp/work/joliet-parker-final-9552.jpg", cat: "Residential" },
  { src: "/mp/work/margarido1293final.jpg", cat: "Residential" },
  { src: "/mp/work/kaseman-1s8a5150.jpg", cat: "Residential" },
  { src: "/mp/work/margarido1353final-new.jpg", cat: "Residential" },
  { src: "/mp/work/mirabel-603.jpg", cat: "Residential" },
  { src: "/mp/work/mirabel-307-edit.jpg", cat: "Residential" },
  { src: "/mp/work/joliet-parker-final-9560.jpg", cat: "Residential" },
  { src: "/mp/work/mirabel-343.jpg", cat: "Residential" },
  { src: "/mp/work/mirabel-423-edit.jpg", cat: "Residential" },
  { src: "/mp/work/mirabel-472-edit.jpg", cat: "Residential" },
  { src: "/mp/work/mirabel-527.jpg", cat: "Residential" },
  { src: "/mp/work/5-6-281-29.jpg", cat: "Residential" },
  { src: "/mp/work/069a4552.jpg", cat: "Residential" },
]

export const LEADERSHIP = [
  {
    name: "Gretchen Krebs",
    role: "Founding Principal",
    bio: "Gretchen Krebs co-founded Medium Plenty with Ian Read and leads the studio's interior design practice. She approaches interiors as an essential part of the architecture — shaping spaces through proportion, light, material, color, and objects to create environments that feel both elevated and deeply livable. She listens closely to how clients want to live and translates those conversations into spaces that feel personal rather than prescribed.",
    cred: ["BFA, Interior Architecture — California College of the Arts", "BA Communications — UCLA"],
    img: "/mp/work/kaseman-1s8a5097.jpg",
  },
  {
    name: "Ian Read",
    role: "Founding Principal",
    bio: "Ian Read co-founded Medium Plenty with Gretchen Krebs, bringing together a formal education in architecture and years of hands-on experience in the construction trades. As Director of Architecture, he leads the studio's architectural work with a deep understanding of how buildings are assembled and an enduring respect for the craftspeople who bring them to life.",
    cred: ["BArch — Philadelphia University", "Licensed Architect in CA, CO & WA", "LEED AP"],
    img: "/mp/work/069a4645.jpg",
  },
  {
    name: "Rami Jetawi",
    role: "Project Management — Abu Dhabi (RJPMS)",
    bio: "Rami Jetawi leads RJPMS (RJ Projects Management Services), an Abu Dhabi-based project management firm overseeing high-end commercial architecture and corporate design fit-outs. The firm is recognized for managing the interior execution and technical delivery of prominent corporate offices and cultural projects across the region — serving as the core project management entity for major international headquarters and design environments established in the UAE.",
    cred: ["RJ Projects Management Services (RJPMS)", "Abu Dhabi, UAE"],
    img: "/mp/ghq-sconce.jpg",
  },
];

export const EXPERTISE = [
  "Workplace",
  "Corporate Headquarters",
  "Tenant Improvements",
  "High-End Residential",
  "Boutique Hospitality",
  "Retail",
  "Adaptive Reuse",
];
